import api from "./api";


const addtNotice = (formData) => {
  return api.post("/addNotice", formData, {
    headers: {
      "Content-Type": "multipart/form-data", // explicitly set for file uploads
    },
  });
};

const getNotices = () => {
  return api.get("/getNotices");
};

const deleteNotice = (noticeId) => {
  return api.delete(`/deleteNotice/${noticeId}`);
};


const register = (data) => {
  return api.post("createEmployee", data);
};

const login = (data) => {
  return api.post("empLogin", data);
};

const changePassword = (data) => {
  return api.post("changePassword", data);
};

const verifyOtp = (data) => {
  return api.post("veryfyOtp", data);
};

const getEmployee = (data) => {
  const queryString = new URLSearchParams(data).toString();
  return api.get(`getEmployes?${queryString}`);
};

const activateEmployee = (data) => {
  return api.post("activateUser", data);
};

const getAllLeads = (queryString) => {
  return api.get(`/getLead?${queryString}`);
};


const getDeadLeads = () => {
  return api.get("/getDeadLead");
};

const getLeadByEmpId = (empId, queryString) => {
  return api.get(`/getLeadByEmpId/${empId}?${queryString}`);
};


const getVendorsByEmpId = (empId, page = 1, limit = 25) => {
  return api.get(`/getVendorsByEmpId/${empId}?page=${page}&limit=${limit}`);
};


const getCounselorLead = (data) => {
  return api.get(`/getCounselorLead/${data}`);
};
const updateLeadByLeadId = (leadId, data) => {
  return api.put(`/updateLead/${leadId}`, data);
};
const updateMarketingLeads = (leadId, data) => {
  return api.put(`/updateMarketingLeads/${leadId}`, data);
};
const getAllTelecaller = () => {
  return api.get("/getAllTelecaller");
};
const getAllCounselor = () => {
  return api.get("/getAllCounselor");
};
const getAllAdminDm = () => {
  return api.get("/getAllAdminDm");
};

const getAllMarketingManager = () => {
  return api.get("/getAllMarketingManager");
};

const getAllVendorManagementExecutive = () => {
  return api.get("/getAllVendorManagementExecutive");
};

const getAllVendorManagementManager = () => {
  return api.get("/getAllVendorManagementManager");
};

const getAllMarketingExecutive = () => {
  return api.get("/getAllMarketingExecutive");
};

const updateProfile = (data) => {
  return api.post("/updateEmp", data);
};
const getAllEmployees = () => {
  return api.get("/getAllEmployees");
};
const deleteLeadByLeadId = (leadId) => {
  return api.delete(`/deleteLead/${leadId}`);
};


const deleteMarketingLeadByLeadId = (leadId) => {
  return api.delete(`/deleteMarketingLead/${leadId}`);
};

const registerStudent = (data) => {
  return api.post(`/registerStudent`, data);
};
const getStudentByEmpId = (empId) => {
  return api.get(`/getStudentByEmpId/${empId}`);
};
const getLeadWithRegistrationStatusByEmpId = (empId) => {
  return api.get(`/getRegLeadByEmpId/${empId}`);
};
const studentAdmission = (data) => {
  return api.post("/admitStudent", data);
};

const uploadMaketingLeadeFile = (data) => {
  return api.post("/marketingLead/upload", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
const uploadLeadeFile = (data) => {
  return api.post("/lead/upload", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
const uploadLeadAudio = (data) => {
  return api.post("/uploadRecording", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
const downloadAudio = async (leadId) => {
  try {
    const response = await api.get(`/downloadRecording/${leadId}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Return response data
    return response.data;
  } catch (error) {
    console.error("Error downloading audio:", error);
    // Rethrow the error to propagate it to the caller
    throw error;
  }
};

const getEmployeeByEmpId = (empId) => {
  return api.get(`/getEmployeeByEmpId/${empId}`);
};

const uploadLead = (file) => {
  return api.post("/lead/upload/", file, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const addLead = (data) => {
  return api.post("/addLead", data);
};

const addMarketingLeads = (data) => {
  return api.post("/addMarketingLeads", data);
};

export const getMarketingLead = (page = 1, limit = 25) => {
  return api.get(`/getMarketingLead?page=${page}&limit=${limit}`);
};

const getRegisteredLeadbyEmpId = (empId, page, limit) => {
  return api.get(`/getRegisteredLeadbyEmpId/${empId}?page=${page}&limit=${limit}`);
};

const getRegisteredLeadbyAdmin = (page, limit) => {
  return api.get(`/getRegisteredLeadbyAdmin?page=${page}&limit=${limit}`);
};

const getAdmissionLeadbyEmpId = (empId, queryString) => {
  return api.get(`/getAdmissionLeadbyEmpId/${empId}?${queryString}`);
};

const getAdmissionLeadbyAdmin = (queryString) => {
  return api.get(`/getAdmissionLeadbyAdmin?${queryString}`);
};


const deleteBulkLead = (data) => {
  return api.delete("/deleteBulkLead", { data: data });
};

const deleteBulkMarketingLead = (data) => {
  return api.delete("/deleteBulkMarketingLead", { data: data });
};

const deadBulkLead = (data) => {
  return api.put("/deadBulkLead", data);
};

const recoverBulkLead = (data) => {
  return api.put("/recoverBulkLead", data);
};

const reporting = (data) => {
  return api.get("/reporting");
};

const getAllCandidates = (page = 1, limit = 50, filters = {}) => {
  return api.get('getAllCandidates', {
    params: {
      page,
      limit,
      ...filters, // adds each filter as a query param
    },
  });
};



const searchCandidatesByTerm = async (term) => {
  return api.get(`searchCandidates?term=${encodeURIComponent(term)}`);
};




const getCandidateByEmpId = (data) => {
  return api.post("getCandidateByEmpId", data); 
};


const assignLocation = (data) => {
  return api.post("assignLocation", data);
};

const assignSector = (data) => {
  return api.post("assignSector", data);
};


const deleteCandidate = (data) => {
  return api.delete("/deleteCandidateByPhone", {
    data: data,
  });
};

const deleteBulkCandidate = (payload) => {
  return api.post("/deleteBulkCandidate", payload); // 👈 Make sure this sends { candidates: [...] }
};

const deleteBulkCompany = (payload) => {
  return api.post("/deleteBulkCompany", payload); // 👈 Make sure this sends { candidates: [...] }
};

const recoverbulkCompany = (data) => {
  return api.put("/recoverBulkCompany", data);
};


const updateCandidateById = (formData) => {
  return api.post(`/updateCandidateById`, formData);
};

const addCompany = (formData) => {
  return api.post(`/addCompany`, formData);
};
const updateCompanyById = (formData) => {
  return api.post(`/updateCompanyById`, formData);
};

const getAllCompany = (queryString) =>
  api.get(`/getAllCompany?${queryString}`);


const getAllUniqueCompany = (formData) => {
  return api.post(`/getAllUniqueCompany`, formData);
};

const getCompanyById = (formData) => {
  return api.post(`/getCompanyById`, formData);
};
const deleteCompanyById = (formData) => {
  return api.post(`/deleteCompanyById`, formData);
};

const deadbulkCompany = (formData) => {
  return api.put(`/deadbulkCompany`, formData);
};
const getdeadCompany = () => {
  return api.get(`/getdeadCompany`);
}



const deleteVacancyById = (formData) => {
  return api.post(`/deleteVacancyById`, formData);
};

const deleteCandidateById = (data) => {
  return api.post("/deleteCandidateById", data);
};

const addInterviewScheduling = (data) => {
  return api.post("/scheduleInterview", data);
};
const getAllScheduledInterview = (queryString) => {
  return api.get(`/getAllScheduledInterview?${queryString}`);
}

const updateInterviewScheduleById = (data) => {
  return api.post("/updateInterviewScheduleById", data);
};
const deleteInterviewById = (data) => {
  return api.post("/deleteInterviewById", data);
};

const getCandidatebyStatus = (data) => {
  return api.post("/getCandidatebyStatus", data);
};

const getAllRecruiters = (data) => {
  return api.get("/getAllRecruiters", data);
};

const addOnboarding = (data) => {
  return api.post("/addOnboarding", data);
};

const updateOnboarding = (data) => {
  return api.post("/updateOnboarding", data);
};

const getJobProfileByCompany = (data) => {
  return api.post("/getJobProfileByCompany", data);
};

const docDownload = (data) => {
  return api.post("/download", data);
};

const docOrgDownload = (data) => {
  return api.post("/orgdownload", data);
};

const addVacancy = (data) => {
  return api.post("/addVacancy", data);
};

const getAllVacancy = (queryString) =>
  api.get(`/getAllVacancy?${queryString}`);


const updateVacancyById = (data) => {
  return api.post("/updateVacancyById", data);
};

const uploadCandidate = (data) => {
  return api.post("/uploadCandidate", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const uploadCompany = (data) => {
  return api.post("/uploadCompany", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getOpenVacancy = (formData) => {
  return api.post(`/getOpenVacancy`, formData);
};

const bulkAssign = (formData) => {
  return api.post(`/bulkAssign`, formData);
};

const edMantra = {
  addtNotice,
  getNotices,
  deleteNotice,
  register,
  login,
  changePassword,
  verifyOtp,
  getEmployee,
  activateEmployee,
  getAllLeads,
  getLeadByEmpId,
  getVendorsByEmpId,
  updateLeadByLeadId,
  updateMarketingLeads,
  getAllCounselor,
  getAllTelecaller,
  getAllAdminDm,
  getAllMarketingManager,
  getAllVendorManagementExecutive,
  getAllVendorManagementManager,
  getAllMarketingExecutive,
  getCounselorLead,
  updateProfile,
  getAllEmployees,
  deleteLeadByLeadId,
  getCompanyById,
  registerStudent,
  getStudentByEmpId,
  getLeadWithRegistrationStatusByEmpId,
  studentAdmission,
  uploadLeadeFile,
  uploadMaketingLeadeFile,
  uploadLeadAudio,
  downloadAudio,
  getEmployeeByEmpId,
  uploadLead,
  addLead,
  addMarketingLeads,
  getMarketingLead,
  getRegisteredLeadbyEmpId,
  getRegisteredLeadbyAdmin,
  getAdmissionLeadbyEmpId,
  getAdmissionLeadbyAdmin,
  deleteBulkLead,
  deleteBulkMarketingLead,
  reporting,
  getAllCandidates,
  getCandidateByEmpId,
  deleteCandidate,
  deleteBulkCandidate,
  deleteBulkCompany,
  recoverbulkCompany,
  updateCandidateById,
  deadBulkLead,
  getdeadCompany,
  getDeadLeads,
  recoverBulkLead,
  addCompany,
  getAllCompany,
  updateCompanyById,
  // getCompanyById,
  deleteCompanyById,
  deadbulkCompany,
  deleteMarketingLeadByLeadId,
  deleteCandidateById,
  addInterviewScheduling,
  getAllScheduledInterview,
  updateInterviewScheduleById,
  deleteInterviewById,
  getCandidatebyStatus,
  getAllRecruiters,
  addOnboarding,
  updateOnboarding,
  getJobProfileByCompany,
  docDownload,
  getAllVacancy,
  addVacancy,
  docOrgDownload,
  updateVacancyById,
  uploadCandidate,
  uploadCompany,
  getAllUniqueCompany,
  getOpenVacancy,
  bulkAssign,
  deleteVacancyById,
  assignLocation,
  assignSector,
  searchCandidatesByTerm,
};

export default edMantra;
